// space between y/x axis and box plot items
export const AXIS_SPACE = 36;
// space between groups
export const GROUP_SPACE = 43;
// height/width of the box plot item
export const BANDWIDTH = 45;
